import { LinkResolver } from "@/components/creators/link-resolver";
import type { ResolvedProgram } from "@/lib/queries/projects";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";

export const Route = createFileRoute(
  "/(legacy)/creators/programs/$programId/interaction/$interactionId",
)({
  component: InteractionRedirect,
});

const TASK_TYPE_ROUTES = {
  SIGN_BRIEF:
    "/o/$orgSlug/p/$profileSlug/c/$campaignId/sign-brief/$interactionId",
  SUBMIT_CONTENT:
    "/o/$orgSlug/p/$profileSlug/c/$campaignId/submit-content/$interactionId",
} as const;

function InteractionRedirect() {
  const { programId, interactionId } = Route.useParams();
  const navigate = useNavigate();

  const handleResolved = useCallback(
    (data: ResolvedProgram) => {
      const interaction = data.interactions.find(
        (i) => String(i.id) === interactionId,
      );

      const taskRoute =
        interaction?.taskType && interaction.taskType in TASK_TYPE_ROUTES
          ? TASK_TYPE_ROUTES[
              interaction.taskType as keyof typeof TASK_TYPE_ROUTES
            ]
          : null;

      if (taskRoute && interaction) {
        void navigate({
          to: taskRoute,
          params: {
            orgSlug: data.orgSlug,
            profileSlug: data.profileSlug,
            campaignId: String(data.campaignId),
            interactionId: String(interaction.id),
          },
          replace: true,
        });
      } else {
        void navigate({
          to: "/o/$orgSlug/p/$profileSlug/c/$campaignId",
          params: {
            orgSlug: data.orgSlug,
            profileSlug: data.profileSlug,
            campaignId: String(data.campaignId),
          },
          replace: true,
        });
      }
    },
    [navigate, interactionId],
  );

  return (
    <LinkResolver programId={Number(programId)} onResolved={handleResolved} />
  );
}
